import { IAddress } from '@/shared/model/address.model';
import Vue from 'vue';
import dayjs from 'dayjs';
import { IMAGE_SERVER_URL } from '@/constants';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_FORMAT_DE = 'DD.MM.YYYY';
export const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm';
export const DATE_TIME_FORMAT_PAYMENT = 'HH:mm DD.MM.YYYY';

export const DATE_TIME_LONG_FORMAT = 'YYYY-MM-DDTHH:mm';

export const TIME_FORMAT = 'HH:mm';

export function initFilters() {
  Vue.filter('formatDate', value => {
    if (value) {
      return dayjs(value).format(DATE_TIME_FORMAT);
    }
    return '';
  });
  Vue.filter('formatDatePayment', value => {
    if (value) {
      return dayjs(value).format(DATE_TIME_FORMAT_PAYMENT);
    }
    return '';
  });
  Vue.filter('formatJustDate', value => {
    if (value) {
      return dayjs(value).format(DATE_FORMAT);
    }
    return '';
  });
  Vue.filter('formatJustDateDE', value => {
    if (value) {
      return dayjs(value).format(DATE_FORMAT_DE);
    }
    return '';
  });
  Vue.filter('formatTime', value => {
    if (value) {
      return dayjs(value).format(TIME_FORMAT);
    }
    return '_';
  });
  Vue.filter('formatMillis', value => {
    if (value) {
      return dayjs(value).format(DATE_TIME_FORMAT);
    }
    return '';
  });
  Vue.filter('duration', value => {
    if (value) {
      const formatted = dayjs.duration(value).humanize();
      if (formatted) {
        return formatted;
      }
      return value;
    }
    return '';
  });

  Vue.filter('formatAddress', value => {
    if (value) {
      const address: IAddress = value;
      return formatString(address.street) + ', ' + formatString(address.zipcode) + ' ' + formatString(address.city);
    }
    return '';
  });

  Vue.filter('renderAsset', assetPath => {
    if (assetPath) {
      return `${IMAGE_SERVER_URL}/api/public/assets/${assetPath}`;
    }

    return '';
  });

  Vue.filter('renderSizedAsset', (assetPath, size) => {
    if (assetPath) {
      return `${IMAGE_SERVER_URL}/api/public/assets/${assetPath}/${size}`;
    }

    return '';
  });

  Vue.filter('formatPrice', value => {
    if (value || value === 0) {
      const val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
    }
    return '';
  });
  const formatString = (str: string) => (str ? str : '');
}
